import { render, staticRenderFns } from "./OpticalEdit.vue?vue&type=template&id=3d5e25f7"
import script from "./OpticalEdit.vue?vue&type=script&lang=js"
export * from "./OpticalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports